import l from "../util/net.js";
import r from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import HtmlMessage from "./models/html-message.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import c from "../common/event-logger.js";
import { newInAppMessageFromJson as ut } from "./in-app-message-factory.js";
import { randomInclusive as a } from "../util/math.js";
import G from "../models/request-result.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import u from "../managers/subscription-manager.js";
import pt from "../triggers/models/trigger.js";
import { BRAZE_ACTION_URI_REGEX as to } from "../util/validation-utils.js";
import {
  containsPushPrimerBrazeAction as ft,
  containsUnknownBrazeAction as dt,
  getDecodedBrazeAction as eo,
  ineligibleBrazeActionURLErrorMessage as jt,
  INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES as vt,
} from "../util/braze-actions.js";
import yt from "../Push/utils/push-utils.js";
import h from "../util/request-header-utils.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { FullScreenMessage, ModalMessage, SlideUpMessage } from "./index.js";
export default class ea {
  constructor(t, e, s, i) {
    (this.S = t),
      (this.T = e),
      (this.C = s),
      (this.Cs = i),
      (this.S = t),
      (this.T = e),
      (this.C = s),
      (this.Cs = i),
      (this.Mi = new u()),
      r.F(this.Mi),
      (this.ki = 1e3),
      (this.zi = 6e4),
      (this.Bi = null),
      (this.Ri = null),
      (this._i = null);
  }
  qi() {
    return this.Mi;
  }
  xi(t) {
    return this.Mi.Dt(t);
  }
  Pi() {
    return this.Bi;
  }
  Gi(t) {
    this.Bi = t;
  }
  ut(t, e, s, i) {
    const r = new G();
    let n;
    if (e === d.$i || t instanceof ControlMessage) {
      if (!t.Yt())
        return (
          N.info(
            "This in-app message has already received an impression. Ignoring analytics event.",
          ),
          r
        );
    } else if (e === d.Fi || (t instanceof HtmlMessage && e === d.Oi)) {
      if (!t.$t(i))
        return (
          N.info(
            "This in-app message has already received a click. Ignoring analytics event.",
          ),
          r
        );
    }
    return (
      (n =
        t instanceof ControlMessage
          ? { trigger_ids: [t.triggerId] }
          : this.Xi(t)),
      null == n
        ? r
        : (t.messageExtras && (n.message_extras = t.messageExtras),
          null != s && (n.bid = s),
          c.ut(e, n))
    );
  }
  Hi(t, e) {
    const s = new G();
    if (!t.$t())
      return (
        N.info(
          "This in-app message button has already received a click. Ignoring analytics event.",
        ),
        s
      );
    const i = this.Xi(e);
    return null == i
      ? s
      : t.id === InAppMessageButton.Ji
      ? (N.info(
          "This in-app message button does not have a tracking id. Not logging event to Braze servers.",
        ),
        s)
      : (null != t.id && (i.bid = t.id), c.ut(d.Oi, i));
  }
  Ki(t) {
    const e = t.messageFields;
    return (null != e && e.is_push_primer) || !1;
  }
  Li(t) {
    if (!(t instanceof InAppMessage)) return;
    const e = (t) => {
      if (!t) return;
      const e = eo(t);
      if (dt(e)) return jt(vt.Qi, "In-App Message");
      if (ft(e)) {
        const t = yt.Ui();
        if (!t.Vi) return yt.Wi(t.reason, "In-App Message");
      }
    };
    if (this.Ki(t)) {
      const t = yt.Ui();
      if (!t.Vi) return yt.Wi(t.reason, "In-App Message");
    }
    const s = t.buttons || [];
    let i;
    for (const t of s)
      if (
        t.clickAction === InAppMessage.ClickAction.URI &&
        t.uri &&
        to.test(t.uri) &&
        ((i = e(t.uri)), i)
      )
        return i;
    return t.clickAction === InAppMessage.ClickAction.URI &&
      t.uri &&
      to.test(t.uri)
      ? e(t.uri)
      : void 0;
  }
  Yi(t, e) {
    e !== this._i && this.Zi(), (this.Ri = t), (this._i = e);
  }
  Zi() {
    null != this.Ri &&
      (clearTimeout(this.Ri), (this.Ri = null), (this._i = null));
  }
  Ir(t, e, s, i) {
    const r = this.S;
    if (!r) return;
    this._i && t.triggerId !== this._i && (this.Zi(), h.bi(this.C, h.O.Mr));
    const n = r.Ar(!1),
      o = r.H(n);
    (o.template = { trigger_id: t.triggerId, trigger_event_type: e }),
      null != s && (o.template.data = s.Tr());
    const u = r.J(o, h.O.Mr);
    r.V(
      o,
      (r = -1) => {
        const n = this.S;
        if (!n) return;
        const m = new Date().valueOf();
        h.W(this.C, h.O.Mr, m),
          -1 !== r && u.push(["X-Braze-Req-Tokens-Remaining", r.toString()]);
        let c,
          p,
          f = !1;
        l.Y({
          url: `${n.Z()}/template/`,
          data: o,
          headers: u,
          tt: (e) => {
            if (!n.st(o, e, u))
              return void ("function" == typeof t.Br && t.Br());
            if ((n.it(), null == e || null == e.templated_message)) return;
            const s = e.templated_message;
            if (s.type !== pt.qr._r) return;
            const i = ut(s.data);
            if (null == i) return;
            const r = this.Li(i);
            if (r)
              return N.error(r), void ("function" == typeof t.Br && t.Br());
            "function" == typeof t.Er && t.Er(i);
          },
          error: (e) => {
            (f = !0),
              (c = e),
              (p = `getting user personalization for message ${t.triggerId}.`);
          },
          nt: (r, o) => {
            if (new Date().valueOf() - t.Gr < t.Nr) {
              let r = 0;
              if (f) {
                const e = Math.min(t.Nr, this.zi),
                  s = this.ki;
                null == i && (i = s), (r = Math.min(e, a(s, 3 * i)));
              }
              n.rt(
                o,
                () => {
                  this.Ir(t, e, s, r);
                },
                h.O.Mr,
                (e) => this.Yi(e, t.triggerId),
                () => this.Zi(),
                r,
              );
            }
            f && n.et(c, p);
          },
        });
      },
      h.O.Mr,
    );
  }
  Xi(t) {
    if (null == t.triggerId)
      return (
        N.info(
          "The in-app message has no analytics id. Not logging event to Braze servers.",
        ),
        null
      );
    const e = {};
    return null != t.triggerId && (e.trigger_ids = [t.triggerId]), e;
  }
  en(t) {
    return (
      !!this.C &&
      !(
        !(t && t instanceof InAppMessage && t.constructor !== InAppMessage) ||
        t instanceof ControlMessage
      ) &&
      this.C.Bt(s.gt.Fr, t.bt())
    );
  }
  zr() {
    if (!this.C) return null;
    const t = this.C.ft(s.gt.Fr);
    if (!t) return null;
    let e;
    switch (t.type) {
      case InAppMessage.ho.Or:
        e = FullScreenMessage.Xr(t);
        break;
      case InAppMessage.ho.Hr:
      case InAppMessage.ho.bo:
      case InAppMessage.ho.Jo:
        e = HtmlMessage.Xr(t);
        break;
      case InAppMessage.ho.Jr:
      case InAppMessage.ho.Io:
        e = ModalMessage.Xr(t);
        break;
      case InAppMessage.ho.Kr:
        e = SlideUpMessage.Xr(t);
    }
    return e && this.Lr(), e;
  }
  Lr() {
    this.C && this.C.Ut(s.gt.Fr);
  }
}
